module.exports = __webpack_public_path__ + "assets/retina_HypotenuseAndLegDetailed.5c8d83b8ea208b81858a8479364d8c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_HypotenuseAndLegDetailed.png
// module id = 677
// module chunks = 0